import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout(): React.JSX.Element {
  return (
    <div className="auth-layout">
      <Outlet />
    </div>
  );
}
